import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "info-modal" }
const _hoisted_2 = { class: "info-modal-head" }
const _hoisted_3 = {
  class: "info-modal-title",
  "data-qa": "info-modal-title"
}
const _hoisted_4 = { class: "info-modal-body" }
const _hoisted_5 = {
  key: 0,
  class: "confirm-close"
}

import { ref, watch } from 'vue';
import VitaButton from './VitaButton.vue';


const __default__ = {
  name: 'vita-info-modal'
}

interface Props {
  title: string
  modalIcon: string | boolean
  modalSize?: string
  open: boolean
  preventClose?: boolean
  confirmClose?: string
  confirmCloseTitle?: string
  closeOnClickOutside?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    modalIcon: { type: [String, Boolean] },
    modalSize: {},
    open: { type: Boolean },
    preventClose: { type: Boolean },
    confirmClose: {},
    confirmCloseTitle: {},
    closeOnClickOutside: { type: Boolean }
  },
  emits: ['toggleInfoModal', 'open', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const isOpen = ref<boolean>(props.open)
const showConfirm = ref(false)
const emit = __emit;

const close = () => {
  showConfirm.value = false
  emit('close')
  emit('toggleInfoModal')
}

const onClickOutside = () => {
  if (!props.closeOnClickOutside || props.preventClose) return
  if (props.confirmClose) {
    showConfirm.value = true
  } else {
    close()
  }
}

watch(props, (val: Props) => {
  isOpen.value = val.open
  if (val.open) {
    emit('open')
  } else {
    showConfirm.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-wrap",
          onClick: _withModifiers(onClickOutside, ["self"]),
          "data-qa": "info-modal-overlay-close"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal", __props.modalSize])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (__props.modalIcon)
                    ? (_openBlock(), _createBlock(_component_vita_icon, {
                        key: 0,
                        name: __props.modalIcon
                      }, null, 8, ["name"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(__props.title), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["info-modal-close", { 'btn-disabled': __props.preventClose }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.confirmClose ? (showConfirm.value = true) : close())),
                  "data-qa": "info-modal-icon-close"
                }, [
                  _createVNode(_component_vita_icon, { name: "cross-dark" })
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "default", { showConfirm: showConfirm.value }),
                (showConfirm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", null, _toDisplayString(__props.confirmCloseTitle), 1),
                        _createElementVNode("div", null, _toDisplayString(__props.confirmClose), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(VitaButton, {
                          class: "rounded no-shadow",
                          color: "red",
                          width: "inline",
                          onClick: close,
                          "data-qa": "info-modal-button-confirm"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("Да", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(VitaButton, {
                          class: "rounded no-shadow",
                          color: "blue",
                          width: "inline",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showConfirm.value = false)),
                          "data-qa": "info-modal-button-cancel"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Нет", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})